import { useUserStore } from "@/stores/UserStore";
export const tokenFunc = async () => {
  const response = await useUserStore().getHeadwindToken;
  return `Bearer ${response}`;
};

//Bu servis token kontrolü için yapılmıştır yapılacak api isteklerine gönderilecek token buradan alınacaktır.
// Geliştirmeler için; erdemb@iposmobil.com.tr
